import React from 'react';
import { useAuth } from '../../context/AuthContext';
import ContentCalendar from './ContentCalendar';
import { UserRole } from '../../lib/types/auth';

const ContentCalendarWrapper: React.FC = () => {
  const { currentUser } = useAuth();

  // If user is not authenticated, show loading or redirect
  if (!currentUser) {
    return <div>Loading...</div>;
  }

  // Map the user's roles to the expected format for ContentCalendar
  const getUserRole = (): 'Master Admin' | 'CS Admin' | 'Marketing Rep' | 'Marketing Admin' => {
    const roles = currentUser.roles || [];
    
    if (roles.includes(UserRole.MasterAdmin)) {
      return 'Master Admin';
    }
    if (roles.includes(UserRole.CSAdmin)) {
      return 'CS Admin';
    }
    if (roles.includes(UserRole.MarketingAdmin)) {
      return 'Marketing Admin';
    }
    if (roles.includes(UserRole.Marketing)) {
      return 'Marketing Rep';
    }
    
    // Default fallback - this ensures marketing users can access the page
    return 'Marketing Rep';
  };

  return (
    <ContentCalendar
      userRole={getUserRole()}
      userId={currentUser.uid}
      userName={currentUser.displayName || currentUser.email || 'User'}
    />
  );
};

export default ContentCalendarWrapper;
